import { useEffect, useState } from "react";
import { organizerListTablesApi } from "../../api/api";

// Active courts of a club, for the birthday tab (which courts can host a birthday) and for dropping
// from the config a court that was deactivated meanwhile (the back rejects those with a 400).
// `refreshKey` forces a reload: the organizer may have added courts in the CANCHAS tab since.
export default function useClubCourts(clubId, refreshKey = 0) {
  const [state, setState] = useState({ loading: Boolean(clubId), error: "", courts: [] });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!clubId) {
      setState({ loading: false, error: "", courts: [] });
      return undefined;
    }
    let active = true;
    setState((prev) => ({ ...prev, loading: true, error: "" }));
    (async () => {
      try {
        const res = await organizerListTablesApi(clubId);
        const list = Array.isArray(res?.data?.info) ? res.data.info : [];
        const courts = list
          .filter((t) => t.status !== false)
          .map((t) => ({ id: String(t._id), name: t.name || "", sport: t.sport || "" }));
        if (active) setState({ loading: false, error: "", courts });
      } catch (_) {
        if (active) setState({ loading: false, error: "No pudimos cargar las canchas del club.", courts: [] });
      }
    })();
    return () => {
      active = false;
    };
  }, [clubId, refreshKey, attempt]);

  return { ...state, reload: () => setAttempt((n) => n + 1) };
}
